var map = {
	"./css.svg": 9920,
	"./express.svg": 5859,
	"./git.svg": 9908,
	"./github.svg": 4436,
	"./html.svg": 7024,
	"./javascript.svg": 3782,
	"./mongodb.svg": 345,
	"./mysql.svg": 2537,
	"./node.svg": 4419,
	"./php.svg": 2347,
	"./react.svg": 549,
	"./scss.svg": 2769,
	"./vue.svg": 1011,
	"./webpack.svg": 7126,
	"./wordpress.svg": 8458
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5561;